const userAnalyticsLabelFinder = (allDates, isDateSummed) => {
    if (isDateSummed) {
       return "All"
    } else {
       return allDates
    }
}

export default userAnalyticsLabelFinder